export const WorkScroll = {
  data() {
    return {
    scTimer: 0,
    scY: 0,
    }
  },
  created() {
    //scイベント登録
    window.addEventListener("scroll", this.scEvent);
  },
  methods: {
    //scイベントで現在のスクロール値を取得
    scEvent() {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {

        this.scY = window.scrollY;

        clearTimeout(this.scTimer);
        this.scTimer = 0;

      }, 0);
    }
  }
}